import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const connectionString = import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING;

let appInsights = null;
let reactPlugin = null;

if (connectionString) {
  try {
    const browserHistory = createBrowserHistory();
    reactPlugin = new ReactPlugin();
    appInsights = new ApplicationInsights({
      config: {
        connectionString,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory }
        },
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: false,
        enableResponseHeaderTracking: false
      }
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
  } catch (e) {
    console.warn('[AppInsights] Failed to initialize:', e.message);
    appInsights = null;
    reactPlugin = null;
  }
}

export { appInsights, reactPlugin };
